/// <reference path="./../Tag.ts" />
namespace HA.Core.HTML.Form {
    //noinspection TsLint
    export class RadioGroup extends FlexContainer {

        public addRadios(radios: any[]): void {
            radios.forEach((rd: { r: any, l: any }) => {
                this.addRadio(rd.r, rd.l);
            });
        }

        public addRadio(radio, label): void {
            const c = new CFlexContainer();
            const radioEl = new Radio(radio);
            const me = this;
            radioEl.onChange((e: Event) => {me.onRadioChange(radio);});

            c.appendChild(radioEl);
            c.appendChild(new Label(label));
            const c2 = new Container();
            c2.appendChild(c);
            this.appendChild(c2);
        }

        /**
         * @param data
         */
        protected initialize(data: any) {
            super.initialize(data);
            this.spaceAround();
            const radios = this.get("radios");
            if (radios) {
                this.addRadios(radios);
            }
        }

        private onRadioChange(e: any): void {
            const func = this.get("onRadioChange");
            func(e);
        }
    }
}
